define('viewModels/primaryNav',[
    'config',
    'lib/lodash4',
    'lib/knockout',
    'services/localeService',
    'services/embeddingService',
    'services/authService',
    'util/NavBuilder'
], function (
    config,
    _,
    ko,
    localeService,
    embeddingService,
    authService,
    NavBuilder
) {
    'use strict';

    function sendSubLinks(updatedNavTree) {
        var filteredNav = filterSubLinks(_.compact(updatedNavTree));
        embeddingService.registerNavigation(filteredNav);
    }

    function buildNav (navBuilder) {

        navBuilder

            //=======================
            // Supervisor Dashboard
            //=======================

            .entry('supervisor.nav.overview', '#dashboard')
                .requireAuth({ any: ['role:qualityAdmin', 'role:qualityEvaluator', 'perm:quality:evaluation:add', 'perm:quality:calibration:view', 'perm:quality:evaluation:editScore', 'perm:quality:evaluation:edit'], ignoreDivisions: true})
                .notWithFeatures('WEM-1242_Evaluation-Dashboard-Deprecation')

            //============================
            // Interactions
            //============================
            .entry('supervisor.nav.interactions', '#admin/interactions')
                .requireAuth('role:qualityAdmin', 'role:qualityEvaluator', 'perm:conversation:communication:view')

            //============================
            // Architect
            //============================
            .entry('admin.nav.architect', config.architect.uri)
                .newWindow('architect')
                .requireAuth('perm:architect:user:admin', 'perm:architect:user:editor', 'perm:architect:user:readonly')
                .notWithFeatures('archGranularPermissions')


            //============================
            // Outbound Dialing
            //============================
            .placeholderFor('outbound-component')

            //============================
            // Quality Admin
            //============================
            .placeholderFor('quality-component');
    }

    var navBuilder = new NavBuilder();

    // Recursively remove links we don't have roles for.
    var filterSubLinks = function (linkData) {
        return _.filter(linkData, function (link) {
            if (link.subLinks) {
                link.subLinks = filterSubLinks(link.subLinks);
            }

            return _.isEmpty(link.roles) ?
                true :
                authService.hasAuthorization(link.roles);
        });
    };

    sendSubLinks(navBuilder.navTree());
    navBuilder.navTree.subscribe(sendSubLinks);

    ko.computed(function() {
        if(localeService.initialized()){
            _.defer(function() {
                buildNav(navBuilder);
            });
        }
    });

    return {
        entries: navBuilder.navTree,
        registerComponentEntries: function (componentName, entries, navParent) {
            navBuilder.registerEntries(componentName + '-component', entries, navParent);
        }
    };
});

